/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-empty */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useCallback, useRef } from "react";
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import { Box, Button, CircularProgress, IconButton, TextField, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import HistoryIcon from "@mui/icons-material/History";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useNativeAuth } from "context/NativeAuthContext";
import { protectedResources } from "authConfig";

const API = protectedResources.apiTodoList.endpoint;
const SCOPES = protectedResources.apiTodoList.scopes?.[0]
  ? [protectedResources.apiTodoList.scopes[0]]
  : [];

// Prioritisation-matrix rating colours (VL→E), matching the dashboard/theme badges.
const RATING_COLORS = { VL: "#c8e6c9", L: "#388e3c", M: "#fdd835", H: "#ef6c00", E: "#c62828" };

// ── Lightweight markdown renderer for the board-paper draft preview ─────────────
// Renders the report's markdown subset (# / ## / ### headings, **bold**, - bullet lists, --- rules,
// paragraphs) as formatted React elements — mirrors the Word document so the chat preview no longer
// shows raw markdown syntax. Matches the grammar of markdownToDocxChildren on the API side.
function renderInline(text, keyBase) {
  return String(text)
    .split(/(\*\*[^*]+\*\*)/g)
    .map((p, i) =>
      p.startsWith("**") && p.endsWith("**") ? (
        <strong key={`${keyBase}-b${i}`}>{p.slice(2, -2)}</strong>
      ) : (
        <React.Fragment key={`${keyBase}-t${i}`}>{p}</React.Fragment>
      )
    );
}

function renderReportMarkdown(md) {
  const lines = String(md || "").split("\n");
  const out = [];
  let bullets = null;
  const flushBullets = () => {
    if (bullets && bullets.length) {
      const k = out.length;
      out.push(
        <Box component="ul" key={`ul-${k}`} sx={{ my: 0.5, pl: 2.5 }}>
          {bullets.map((b, i) => (
            <li
              key={i}
              style={{ marginBottom: 2, fontSize: 13, lineHeight: 1.5, color: "#344767" }}
            >
              {renderInline(b, `li-${k}-${i}`)}
            </li>
          ))}
        </Box>
      );
    }
    bullets = null;
  };
  lines.forEach((raw, idx) => {
    const line = raw.replace(/\s+$/, "");
    const bulletMatch = /^\s*[-*]\s+(.*)$/.exec(line);
    if (bulletMatch) {
      if (!bullets) bullets = [];
      bullets.push(bulletMatch[1]);
      return;
    }
    flushBullets();
    if (line.startsWith("# ")) {
      out.push(
        <Typography
          key={idx}
          sx={{ fontSize: 16, fontWeight: 800, color: "#222", mt: idx ? 1.25 : 0, mb: 0.75 }}
        >
          {renderInline(line.slice(2), `h1-${idx}`)}
        </Typography>
      );
    } else if (line.startsWith("## ")) {
      out.push(
        <Typography
          key={idx}
          sx={{ fontSize: 14, fontWeight: 700, color: "#52009b", mt: 1.1, mb: 0.5 }}
        >
          {renderInline(line.slice(3), `h2-${idx}`)}
        </Typography>
      );
    } else if (line.startsWith("### ")) {
      out.push(
        <Typography
          key={idx}
          sx={{ fontSize: 13, fontWeight: 700, color: "#344767", mt: 0.9, mb: 0.4 }}
        >
          {renderInline(line.slice(4), `h3-${idx}`)}
        </Typography>
      );
    } else if (/^---+$/.test(line.trim())) {
      out.push(<Box key={idx} sx={{ borderTop: "1px solid #e3def0", my: 1 }} />);
    } else if (line.trim() !== "") {
      out.push(
        <Typography key={idx} sx={{ fontSize: 13, lineHeight: 1.55, color: "#344767", mb: 0.6 }}>
          {renderInline(line, `p-${idx}`)}
        </Typography>
      );
    }
  });
  flushBullets();
  return out;
}

// ── Token helper ──────────────────────────────────────────────────────────────

function useAuthToken() {
  const { instance } = useMsal();
  const { getAccessToken: getNativeAccessToken } = useNativeAuth();

  const getToken = useCallback(async () => {
    const native = getNativeAccessToken();
    if (native) return native;
    const account = instance.getActiveAccount();
    if (account && SCOPES.length) {
      const silent = await instance.acquireTokenSilent({ scopes: SCOPES, account });
      return silent?.accessToken || null;
    }
    return null;
  }, [instance, getNativeAccessToken]);

  return getToken;
}

// ── Streaming fetch ───────────────────────────────────────────────────────────

async function streamMessage(url, body, token, onEvent) {
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const lines = buf.split("\n");
    buf = lines.pop();
    for (const line of lines) {
      if (!line.startsWith("data:")) continue;
      const payload = line.slice(5).trim();
      if (!payload) continue;
      try {
        onEvent(JSON.parse(payload));
      } catch (_) {}
    }
  }
}

// ── Action proposal card ──────────────────────────────────────────────────────

// Rendered when the advisor proposes an action (create watchlist risk / horizon search).
// Nothing is created until the user clicks the confirm button.
const REPORT_TYPE_LABEL = {
  strategic: "Strategic (board)",
  operational: "Operational",
  tactical: "Tactical / action",
};

const LENGTH_LABEL = {
  short: "Short (~1 page)",
  standard: "Standard (~2 pages)",
  detailed: "Detailed (~4 pages)",
};

// Human-readable reporting period for a board_paper proposal.
function boardPaperPeriodLabel(data) {
  if (data.dateFrom && data.dateTo) return `${data.dateFrom} → ${data.dateTo}`;
  const m = Number(data.periodMonths);
  if (m > 0) return `Last ${m} month${m === 1 ? "" : "s"}`;
  return "Current snapshot";
}

function ProposalCard({
  proposal,
  onConfirm,
  onDismiss,
  onOpen,
  onOpenBoardPaper,
  onSave,
  onRegenerate,
}) {
  const { kind, data = {}, busy, done, error, result, draft } = proposal;
  const isRisk = kind === "risk";
  const isBoardPaper = kind === "board_paper";
  const [tweak, setTweak] = useState("");

  let heading = "Create this horizon scan search?";
  if (isRisk) heading = "Add this to your watchlist?";
  else if (isBoardPaper) heading = "Generate this board paper?";

  let threatType = "";
  if (data.threatOpp === "gain") threatType = "Opportunity";
  else if (data.threatOpp === "loss") threatType = "Threat";

  let rows = [
    ["Search", data.name],
    ["Category", data.category],
    ["Cadence", data.ingestTier === "instant" ? "Instant" : "Daily"],
    ["Criticality", data.criticality],
  ];
  if (isRisk) {
    rows = [
      ["Risk", data.title],
      ["Category", [data.category, data.subCategory].filter(Boolean).join(" › ")],
      ["Time frame", data.timeFrame],
      ["Type", threatType],
    ];
  } else if (isBoardPaper) {
    let focus = "Whole portfolio";
    if (Array.isArray(data.focusRisks) && data.focusRisks.length) {
      focus = data.focusRisks.join(", ");
    } else if (Array.isArray(data.focusCategories) && data.focusCategories.length) {
      const l2 =
        Array.isArray(data.focusSubCategories) && data.focusSubCategories.length
          ? ` › ${data.focusSubCategories.join(", ")}`
          : "";
      focus = `${data.focusCategories.join(", ")}${l2}`;
    }
    const horizonFocus =
      Array.isArray(data.focusHorizonParams) && data.focusHorizonParams.length
        ? data.focusHorizonParams.join(", ")
        : "";
    rows = [
      ["Depth", REPORT_TYPE_LABEL[data.reportType] || REPORT_TYPE_LABEL.strategic],
      ["Focus", focus],
      ["Horizon focus", horizonFocus],
      ["Period", boardPaperPeriodLabel(data)],
      ["Length", LENGTH_LABEL[data.length] || LENGTH_LABEL.standard],
      ["Charts", data.includeCharts === false ? "No" : "Yes"],
      ["Template", data.template],
      ["Format", data.outputFormat === "pptx" ? "Slides (PPTX)" : "Word (DOCX)"],
    ];
  }

  if (done) {
    return (
      <Box
        sx={{
          alignSelf: "flex-start",
          maxWidth: "90%",
          border: "1px solid #c8e6c9",
          bgcolor: "#f1f8f2",
          borderRadius: 2,
          px: 1.5,
          py: 1,
          fontSize: 14,
          color: "#1b5e20",
        }}
      >
        <Box>
          {isRisk && `Added “${data.title}” to your watchlist as a draft.`}
          {isBoardPaper && "Your board paper is ready."}
          {!isRisk && !isBoardPaper && `Created the “${data.name}” horizon scan search.`}
        </Box>
        {isRisk && result && result.id && (
          <Button
            size="small"
            variant="text"
            onClick={() => onOpen && onOpen(result.id)}
            sx={{
              mt: 0.5,
              p: 0,
              minWidth: 0,
              color: "#52009b",
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Open risk →
          </Button>
        )}
        {isBoardPaper && result && result.reportId && (
          <Button
            size="small"
            variant="text"
            onClick={() => onOpenBoardPaper && onOpenBoardPaper(result.reportId)}
            sx={{
              mt: 0.5,
              p: 0,
              minWidth: 0,
              color: "#52009b",
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Open board paper →
          </Button>
        )}
      </Box>
    );
  }

  // Two-step board paper: once drafted (and not yet saved), show the report TEXT for review with
  // Save / Regenerate, instead of the scope card. Nothing is persisted until Save.
  if (isBoardPaper && draft && !done) {
    return (
      <Box
        sx={{
          alignSelf: "flex-start",
          maxWidth: "92%",
          border: "1px solid rgba(82,0,155,0.35)",
          bgcolor: "#fff",
          borderRadius: 2,
          px: 1.5,
          py: 1.25,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
      >
        <Typography
          variant="caption"
          sx={{ fontWeight: 700, color: "#52009b", letterSpacing: 0.3, display: "block", mb: 0.75 }}
        >
          Draft report — review before saving
        </Typography>
        <Box
          sx={{
            maxHeight: 440,
            overflowY: "auto",
            border: "1px solid #ece8f3",
            borderRadius: 1,
            p: 1.25,
            bgcolor: "#faf9fc",
          }}
        >
          {renderReportMarkdown(draft.llmContent)}
          {draft.charts &&
            (draft.charts.universe || draft.charts.topRisks || draft.charts.position) && (
              <Box sx={{ mt: 1.5, pt: 1, borderTop: "1px solid #e3def0" }}>
                <Typography
                  sx={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#52009b",
                    textTransform: "uppercase",
                    letterSpacing: 0.4,
                    mb: 0.75,
                  }}
                >
                  Charts included in the saved report
                </Typography>
                {draft.charts.universe && (
                  <Box sx={{ mb: 1.5 }}>
                    <Box
                      component="img"
                      src={draft.charts.universe.src}
                      alt="Risk Universe map"
                      sx={{
                        width: "100%",
                        borderRadius: 1,
                        border: "1px solid #eee",
                        display: "block",
                      }}
                    />
                    {draft.charts.universe.note && (
                      <Typography sx={{ fontSize: 11, color: "#7b809a", mt: 0.4, lineHeight: 1.4 }}>
                        {draft.charts.universe.note}
                      </Typography>
                    )}
                    {Array.isArray(draft.charts.universe.legend) &&
                      draft.charts.universe.legend.length > 0 && (
                        <Box
                          component="ol"
                          sx={{ fontSize: 11, color: "#344767", m: 0, mt: 0.5, pl: 2.25 }}
                        >
                          {draft.charts.universe.legend.map((l, i) => (
                            <li key={i} style={{ marginBottom: 1 }}>
                              {String(l).replace(/^\d+\.\s*/, "")}
                            </li>
                          ))}
                        </Box>
                      )}
                  </Box>
                )}
                {draft.charts.topRisks && (
                  <Box sx={{ mb: 1.5 }}>
                    <Box
                      component="img"
                      src={draft.charts.topRisks.src}
                      alt="Top Watch-List Risks"
                      sx={{
                        width: "100%",
                        borderRadius: 1,
                        border: "1px solid #eee",
                        display: "block",
                      }}
                    />
                    {draft.charts.topRisks.note && (
                      <Typography sx={{ fontSize: 11, color: "#7b809a", mt: 0.4, lineHeight: 1.4 }}>
                        {draft.charts.topRisks.note}
                      </Typography>
                    )}
                  </Box>
                )}
                {draft.charts.position && (
                  <Box
                    component="img"
                    src={draft.charts.position.src}
                    alt="Risk position"
                    sx={{
                      width: "100%",
                      borderRadius: 1,
                      border: "1px solid #eee",
                      display: "block",
                    }}
                  />
                )}
              </Box>
            )}
        </Box>
        <Typography sx={{ color: "#7b809a", fontSize: 11.5, mt: 0.75, lineHeight: 1.4 }}>
          Nothing is saved yet — this is a preview. “Save as report” stores it (with these charts
          and signpost trends) and adds it to the report library.
        </Typography>
        {error && (
          <Typography sx={{ color: "#c62828", fontSize: 12.5, mt: 0.75 }}>{error}</Typography>
        )}
        {busy && (
          <Typography sx={{ color: "#7b809a", fontSize: 12, mt: 0.75, fontStyle: "italic" }}>
            Working…
          </Typography>
        )}
        <Box sx={{ display: "flex", gap: 1, mt: 1, flexWrap: "wrap", alignItems: "center" }}>
          <Button
            size="small"
            variant="contained"
            disabled={busy}
            onClick={onSave}
            startIcon={busy ? <CircularProgress size={14} color="inherit" /> : <AddIcon />}
            sx={{
              bgcolor: "#52009b",
              color: "#fff",
              textTransform: "none",
              "&:hover": { bgcolor: "#42007e" },
            }}
          >
            Save as report
          </Button>
          <TextField
            size="small"
            placeholder="Optional change, e.g. shorten the cyber section"
            value={tweak}
            onChange={(e) => setTweak(e.target.value)}
            disabled={busy}
            sx={{ flex: 1, minWidth: 190 }}
          />
          <Button
            size="small"
            disabled={busy}
            onClick={() => onRegenerate && onRegenerate(tweak)}
            sx={{ color: "#52009b", textTransform: "none" }}
          >
            Regenerate
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        alignSelf: "flex-start",
        maxWidth: "90%",
        border: "1px solid rgba(82,0,155,0.35)",
        bgcolor: "#fff",
        borderRadius: 2,
        px: 1.5,
        py: 1.25,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, color: "#52009b", letterSpacing: 0.3, display: "block", mb: 0.75 }}
      >
        {heading}
      </Typography>
      {rows
        .filter(([, v]) => v)
        .map(([label, v]) => (
          <Box key={label} sx={{ display: "flex", gap: 1, py: 0.25, fontSize: 13 }}>
            <Typography sx={{ minWidth: 82, color: "#7b809a", fontSize: 13, flexShrink: 0 }}>
              {label}
            </Typography>
            <Typography sx={{ color: "#344767", fontSize: 13, fontWeight: 500 }}>{v}</Typography>
          </Box>
        ))}
      {data.description && (
        <Typography sx={{ color: "#4a4658", fontSize: 12.5, mt: 0.5, lineHeight: 1.45 }}>
          {data.description}
        </Typography>
      )}
      {isBoardPaper && (data.dateFrom || Number(data.periodMonths) > 0) && (
        <Typography sx={{ color: "#7b809a", fontSize: 11.5, mt: 0.5, lineHeight: 1.4 }}>
          The period scopes the news &amp; emerging themes analysed. Watch-list risk positions
          always reflect their current assessment.
        </Typography>
      )}
      {error && (
        <Typography sx={{ color: "#c62828", fontSize: 12.5, mt: 0.75 }}>{error}</Typography>
      )}
      {isBoardPaper && busy && (
        <Typography sx={{ color: "#7b809a", fontSize: 12, mt: 0.75, fontStyle: "italic" }}>
          Drafting your board paper from the live portfolio — this can take up to a minute.
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
        <Button
          size="small"
          variant="contained"
          disabled={busy}
          onClick={onConfirm}
          startIcon={busy ? <CircularProgress size={14} color="inherit" /> : <AddIcon />}
          sx={{
            bgcolor: "#52009b",
            color: "#fff",
            textTransform: "none",
            "&:hover": { bgcolor: "#42007e" },
          }}
        >
          {isRisk && "Add to watchlist"}
          {isBoardPaper && "Generate board paper"}
          {!isRisk && !isBoardPaper && "Create search"}
        </Button>
        <Button
          size="small"
          disabled={busy}
          onClick={onDismiss}
          sx={{ color: "#7b809a", textTransform: "none" }}
        >
          Not now
        </Button>
      </Box>
    </Box>
  );
}

// Compact relative time for the saved-chats list (e.g. "3m", "2h", "Mon").
function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const s = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return new Date(then).toLocaleDateString();
}

// ── Main page ─────────────────────────────────────────────────────────────────

export default function RiskAdvisor() {
  const getToken = useAuthToken();
  const navigate = useNavigate();
  // Report mode (?mode=report) — reached from the "Generate Report" button. Same chat engine as
  // Ask PAGER (identical capabilities); only the heading and suggested starters are report-flavoured.
  const [searchParams] = useSearchParams();
  const reportMode = searchParams.get("mode") === "report";

  const [brief, setBrief] = useState(null); // { emergingThemes, activeRisks, counts } — opening feed
  const [askMessages, setAskMessages] = useState([]); // { role: 'user'|'assistant', text } — Ask PAGER thread
  const [askInput, setAskInput] = useState("");
  const [asking, setAsking] = useState(false);

  // Save/resume — the thread is auto-saved after each exchange and listed in the history sidebar.
  const [chatId, setChatId] = useState(null);
  const [chats, setChats] = useState([]);
  const [historyOpen, setHistoryOpen] = useState(false);
  const chatIdRef = useRef(null);
  const messagesRef = useRef(askMessages);
  const saveTimer = useRef(null);
  useEffect(() => {
    chatIdRef.current = chatId;
  }, [chatId]);
  useEffect(() => {
    messagesRef.current = askMessages;
  }, [askMessages]);

  const inputRef = useRef(null);
  const focusInput = useCallback(() => {
    // Defer so it runs after the re-render that re-enables the input / finishes the click.
    setTimeout(() => inputRef.current?.focus(), 0);
  }, []);

  // Keep the typing cursor in the chat input: a disabled input (while a reply streams) drops focus,
  // so restore it as soon as streaming ends.
  useEffect(() => {
    if (!asking) focusInput();
  }, [asking, focusInput]);

  // Opening feed — latest emerging themes + watchlist risks to monitor (shown on the welcome screen).
  const loadBrief = useCallback(async () => {
    const token = await getToken();
    if (!token) return;
    try {
      const res = await fetch(`${API}/advisor/brief?themes=6&risks=6`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();
      if (json?.data) setBrief(json.data);
    } catch (_) {}
  }, [getToken]);

  useEffect(() => {
    loadBrief();
  }, [loadBrief]);

  // ── Saved chats (per-user) — list, auto-save, resume, delete ──
  const loadChats = useCallback(async () => {
    const token = await getToken();
    if (!token) return;
    try {
      const res = await fetch(`${API}/advisor/chats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();
      if (Array.isArray(json?.data)) setChats(json.data);
    } catch (_) {}
  }, [getToken]);

  useEffect(() => {
    loadChats();
  }, [loadChats]);

  // Persist the current thread (create or update). Reads from refs so the debounce stays stable.
  const persistChat = useCallback(async () => {
    const messages = messagesRef.current || [];
    const payloadMessages = messages
      .filter((m) => m.role === "user" || m.role === "assistant")
      .map((m) => ({
        role: m.role,
        text: m.text || "",
        proposal: m.proposal
          ? {
              kind: m.proposal.kind,
              data: m.proposal.data || {},
              done: !!m.proposal.done,
              result: m.proposal.result || null,
              // Carry an un-saved board-paper draft so it survives save/resume (server caps it).
              // Drop the preview chart images (base64) from the saved copy to keep state small — they
              // re-render on the next draft/regenerate.
              ...(!m.proposal.done && m.proposal.draft
                ? { draft: { ...m.proposal.draft, charts: undefined } }
                : {}),
            }
          : undefined,
      }));
    if (!payloadMessages.length) return;
    const token = await getToken();
    if (!token) return;
    try {
      const res = await fetch(`${API}/advisor/chats`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          id: chatIdRef.current || undefined,
          mode: reportMode ? "report" : "ask",
          messages: payloadMessages,
        }),
      });
      const json = await res.json().catch(() => ({}));
      const newId = json?.data?.id;
      if (newId && !chatIdRef.current) setChatId(newId);
      loadChats();
    } catch (_) {}
  }, [getToken, reportMode, loadChats]);

  // Auto-save after each completed exchange (debounced). Never mid-stream, and only once the thread
  // has a real user+assistant exchange (so an empty/new chat is not saved).
  useEffect(() => {
    if (asking) return undefined;
    const hasUser = askMessages.some((m) => m.role === "user" && m.text);
    const hasAssistant = askMessages.some((m) => m.role === "assistant" && (m.text || m.proposal));
    if (!hasUser || !hasAssistant) return undefined;
    clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(persistChat, 900);
    return () => clearTimeout(saveTimer.current);
  }, [askMessages, asking, persistChat]);

  const newChat = useCallback(() => {
    setAskMessages([]);
    setAskInput("");
    setChatId(null);
    focusInput();
  }, [focusInput]);

  const resumeChat = useCallback(
    async (id) => {
      const token = await getToken();
      if (!token) return;
      try {
        const res = await fetch(`${API}/advisor/chats/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();
        const chat = json?.data;
        if (!chat) return;
        const msgs = (chat.messages || []).map((m) => ({
          role: m.role,
          text: m.text || "",
          ...(m.proposal ? { proposal: { ...m.proposal, dismissed: false } } : {}),
        }));
        setAskMessages(msgs);
        setChatId(chat.id || id);
        setHistoryOpen(false);
        focusInput();
      } catch (_) {}
    },
    [getToken, focusInput]
  );

  const deleteChat = useCallback(
    async (id, e) => {
      if (e) e.stopPropagation();
      const token = await getToken();
      if (!token) return;
      try {
        await fetch(`${API}/advisor/chats/${id}`, {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        });
        setChats((prev) => prev.filter((c) => c.id !== id));
        if (chatIdRef.current === id) newChat();
      } catch (_) {}
    },
    [getToken, newChat]
  );

  // Ask PAGER — grounded Q&A over the tenant's themes + watchlist (streams from /advisor/ask).
  const askPager = useCallback(
    async (explicit) => {
      const q = (typeof explicit === "string" ? explicit : askInput).trim();
      if (!q || asking) return;
      setAskInput("");
      const history = askMessages.slice(-8);
      setAskMessages((m) => [...m, { role: "user", text: q }, { role: "assistant", text: "" }]);
      setAsking(true);
      const token = await getToken();
      try {
        await streamMessage(`${API}/advisor/ask`, { message: q, history }, token, (ev) => {
          if (ev.type === "text_delta") {
            setAskMessages((m) => {
              const copy = m.slice();
              const last = copy[copy.length - 1];
              if (last && last.role === "assistant") {
                copy[copy.length - 1] = { ...last, text: last.text + ev.text };
              }
              return copy;
            });
          } else if (ev.type === "proposal") {
            setAskMessages((m) => {
              const copy = m.slice();
              const last = copy[copy.length - 1];
              if (last && last.role === "assistant") {
                copy[copy.length - 1] = {
                  ...last,
                  proposal: { kind: ev.kind, data: ev.data || {} },
                };
              }
              return copy;
            });
          }
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          const last = copy[copy.length - 1];
          if (last && last.role === "assistant" && !last.text) {
            copy[copy.length - 1] = { ...last, text: "Sorry — I couldn't answer that just now." };
          }
          return copy;
        });
      }
      setAsking(false);
    },
    [askInput, asking, askMessages, getToken]
  );

  // Confirm a proposed action (create watchlist risk / horizon search) — POST /advisor/confirm.
  const confirmAction = useCallback(
    async (idx) => {
      const target = askMessages[idx];
      const proposal = target && target.proposal;
      if (!proposal || proposal.busy || proposal.done) return;
      setAskMessages((m) => {
        const copy = m.slice();
        if (copy[idx])
          copy[idx] = { ...copy[idx], proposal: { ...copy[idx].proposal, busy: true } };
        return copy;
      });
      const token = await getToken();
      try {
        const res = await fetch(`${API}/advisor/confirm`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({ kind: proposal.kind, data: proposal.data }),
        });
        const json = await res.json().catch(() => ({}));
        const ok = res.ok && json?.status !== false && json?.success !== false;
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx]) {
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                done: ok,
                result: ok ? json?.data || {} : null,
                error: ok ? null : json?.message || "Couldn't complete that action.",
              },
            };
          }
          return copy;
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: "Couldn't complete that action.",
              },
            };
          return copy;
        });
      }
    },
    [askMessages, getToken]
  );

  const dismissAction = useCallback((idx) => {
    setAskMessages((m) => {
      const copy = m.slice();
      if (copy[idx])
        copy[idx] = { ...copy[idx], proposal: { ...copy[idx].proposal, dismissed: true } };
      return copy;
    });
  }, []);

  // Generate a board paper from a confirmed board_paper proposal — drives the existing report
  // generator (POST /boardPaper/generate) with the conversational scope, then offers to open it.
  const generateBoardPaper = useCallback(
    async (idx) => {
      const target = askMessages[idx];
      const proposal = target && target.proposal;
      if (!proposal || proposal.busy || proposal.done) return;
      setAskMessages((m) => {
        const copy = m.slice();
        if (copy[idx])
          copy[idx] = {
            ...copy[idx],
            proposal: { ...copy[idx].proposal, busy: true, error: null },
          };
        return copy;
      });
      focusInput(); // clicking Generate blurs the input — give the cursor back so the user can keep chatting
      const d = proposal.data || {};
      const token = await getToken();

      // Map the natural-language length to the generator's page spec.
      const LENGTH_PAGES = { short: "1 page", standard: "2 pages", detailed: "4 pages" };

      // Resolve specific named risks → watchlist risk ids (best-effort, case-insensitive match).
      let watchlistRiskIds = [];
      if (Array.isArray(d.focusRisks) && d.focusRisks.length) {
        try {
          const lr = await fetch(`${API}/emergingRisk/list`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const lj = await lr.json().catch(() => ({}));
          const risks = Array.isArray(lj?.data) ? lj.data : [];
          const wanted = d.focusRisks.map((s) => String(s).toLowerCase().trim()).filter(Boolean);
          watchlistRiskIds = risks
            .filter((r) => {
              const title = String(r.Title || r.title || "").toLowerCase();
              return title && wanted.some((w) => title.includes(w) || w.includes(title));
            })
            .map((r) => String(r._id || r.id))
            .filter(Boolean);
        } catch (_) {
          /* fall back to category / whole-portfolio scope */
        }
      }

      // Resolve a named stored template → its id (case-insensitive). The template's own format
      // (docx/pptx) then wins for the output, so "use the exec slides template" produces slides.
      let templateId;
      let templateFormat;
      if (d.template && String(d.template).trim()) {
        try {
          const tr = await fetch(`${API}/reportTemplate/list`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const tj = await tr.json().catch(() => ({}));
          const tpls = Array.isArray(tj?.data) ? tj.data : [];
          const want = String(d.template).toLowerCase().trim();
          const match =
            tpls.find(
              (t) =>
                String(t.name || "")
                  .toLowerCase()
                  .trim() === want
            ) ||
            tpls.find((t) => {
              const nm = String(t.name || "")
                .toLowerCase()
                .trim();
              return nm && (nm.includes(want) || want.includes(nm));
            });
          if (match) {
            templateId = match.id || match._id;
            templateFormat = match.format;
          }
        } catch (_) {
          /* fall back to default formatting */
        }
      }

      // Resolve named Horizon Scan collections (company-search parameter name OR category) → ids, so
      // the paper's emerging-theme analysis is scoped to just those collections.
      let horizonParamIds = [];
      if (Array.isArray(d.focusHorizonParams) && d.focusHorizonParams.length) {
        try {
          const pr = await fetch(`${API}/companySearchParameters/list`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const pj = await pr.json().catch(() => ({}));
          const params = Array.isArray(pj?.data) ? pj.data : [];
          const wanted = d.focusHorizonParams
            .map((s) => String(s).toLowerCase().trim())
            .filter(Boolean);
          horizonParamIds = params
            .filter((p) => {
              const nm = String(p.name || "").toLowerCase();
              const cat = String(p.category || "").toLowerCase();
              return wanted.some(
                (w) => (nm && (nm === w || nm.includes(w) || w.includes(nm))) || (cat && cat === w)
              );
            })
            .map((p) => String(p._id || p.id))
            .filter(Boolean);
        } catch (_) {
          /* fall back to the taxonomy / whole-portfolio scope */
        }
      }

      // Reporting period → date range (explicit dates win; else a relative month lookback).
      let dateMode = "current";
      let dateFrom;
      let dateTo;
      if (d.dateFrom && d.dateTo) {
        dateMode = "date-range";
        dateFrom = d.dateFrom;
        dateTo = d.dateTo;
      } else if (Number(d.periodMonths) > 0) {
        const to = new Date();
        const from = new Date();
        from.setMonth(from.getMonth() - Number(d.periodMonths));
        dateMode = "date-range";
        dateFrom = from.toISOString().slice(0, 10);
        dateTo = to.toISOString().slice(0, 10);
      }

      const body = {
        reportType: ["strategic", "operational", "tactical"].includes(d.reportType)
          ? d.reportType
          : "strategic",
        scope: "all",
        includeCharts: d.includeCharts !== false,
        anticipatory: true,
        riskCategoriesL1: Array.isArray(d.focusCategories) ? d.focusCategories : [],
        riskCategoriesL2: Array.isArray(d.focusSubCategories) ? d.focusSubCategories : [],
        watchlistRiskIds,
        horizonParamIds,
        length: LENGTH_PAGES[d.length] || "2 pages",
        dateMode,
        dateFrom,
        dateTo,
        structure: d.notes || "",
        // A chosen template's format wins; otherwise honour the requested output format.
        outputFormat: templateFormat || (d.outputFormat === "pptx" ? "pptx" : "docx"),
        templateId,
      };
      try {
        // Step 1 of the two-step flow: draft the report TEXT only — nothing is saved yet. The text
        // renders in the chat for review; the user then saves it (finalize) or regenerates it.
        const res = await fetch(`${API}/boardPaper/draft`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify(body),
        });
        const json = await res.json().catch(() => ({}));
        const text = json?.data?.llmContent;
        const ok = res.ok && json?.success !== false && text;
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: ok ? null : json?.message || "Couldn't draft the board paper.",
                draft: ok
                  ? {
                      llmContent: text,
                      parameters: body,
                      promptTokens: json.data.promptTokens || 0,
                      outputTokens: json.data.outputTokens || 0,
                      charts: json.data.charts || null,
                    }
                  : copy[idx].proposal.draft || null,
              },
            };
          return copy;
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: "Couldn't draft the board paper.",
              },
            };
          return copy;
        });
      }
    },
    [askMessages, getToken]
  );

  // Step 2 — save the reviewed draft: builds the document (with charts) and adds it to the report
  // library. Only now is anything persisted to the DB / table.
  const finalizeBoardPaper = useCallback(
    async (idx) => {
      const target = askMessages[idx];
      const proposal = target && target.proposal;
      if (!proposal || proposal.busy || proposal.done || !proposal.draft) return;
      setAskMessages((m) => {
        const copy = m.slice();
        if (copy[idx])
          copy[idx] = {
            ...copy[idx],
            proposal: { ...copy[idx].proposal, busy: true, error: null },
          };
        return copy;
      });
      focusInput();
      try {
        const token = await getToken();
        const res = await fetch(`${API}/boardPaper/finalize`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({
            llmContent: proposal.draft.llmContent,
            parameters: proposal.draft.parameters,
            promptTokens: proposal.draft.promptTokens || 0,
            outputTokens: proposal.draft.outputTokens || 0,
          }),
        });
        const json = await res.json().catch(() => ({}));
        const ok = res.ok && json?.success !== false && json?.data?.reportId;
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                done: !!ok,
                result: ok ? json.data : null,
                error: ok ? null : json?.message || "Couldn't save the board paper.",
              },
            };
          return copy;
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: "Couldn't save the board paper.",
              },
            };
          return copy;
        });
      }
    },
    [askMessages, getToken]
  );

  // Regenerate the draft with an optional reviewer tweak (e.g. "shorten the cyber section"). Reuses
  // the already-resolved parameters so the scope stays identical.
  const regenerateBoardPaper = useCallback(
    async (idx, tweak) => {
      const target = askMessages[idx];
      const proposal = target && target.proposal;
      if (!proposal || proposal.busy || !proposal.draft) return;
      setAskMessages((m) => {
        const copy = m.slice();
        if (copy[idx])
          copy[idx] = {
            ...copy[idx],
            proposal: { ...copy[idx].proposal, busy: true, error: null },
          };
        return copy;
      });
      focusInput();
      try {
        const token = await getToken();
        const res = await fetch(`${API}/boardPaper/draft`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({ ...proposal.draft.parameters, tweakInstruction: tweak || "" }),
        });
        const json = await res.json().catch(() => ({}));
        const text = json?.data?.llmContent;
        const ok = res.ok && json?.success !== false && text;
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: ok ? null : json?.message || "Couldn't regenerate the draft.",
                draft: ok
                  ? {
                      ...copy[idx].proposal.draft,
                      llmContent: text,
                      promptTokens: json.data.promptTokens || 0,
                      outputTokens: json.data.outputTokens || 0,
                      charts: json.data.charts || null,
                    }
                  : copy[idx].proposal.draft,
              },
            };
          return copy;
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: "Couldn't regenerate the draft.",
              },
            };
          return copy;
        });
      }
    },
    [askMessages, getToken]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ display: "flex", height: "calc(100vh - 96px)", gap: 0, overflow: "hidden" }}>
        {/* ── History sidebar (saved chats) ── */}
        <Box
          sx={{
            width: historyOpen ? 264 : 0,
            flexShrink: 0,
            transition: "width 0.18s ease",
            overflow: "hidden",
            borderRight: historyOpen ? "1px solid #ece7f3" : "none",
            bgcolor: "#faf9fc",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              p: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #f1eef7",
            }}
          >
            <Typography sx={{ fontWeight: 700, color: "#52009b", fontSize: 14 }}>
              Saved chats
            </Typography>
            <Button
              size="small"
              startIcon={<AddIcon />}
              onClick={newChat}
              sx={{ color: "#52009b", textTransform: "none", minWidth: 0 }}
            >
              New
            </Button>
          </Box>
          <Box sx={{ overflowY: "auto", flex: 1, p: 1 }}>
            {chats.length === 0 ? (
              <Typography variant="body2" color="text.secondary" sx={{ px: 1, py: 0.5 }}>
                No saved chats yet. Your conversations are saved here automatically.
              </Typography>
            ) : (
              chats.map((c) => (
                <Box
                  key={c.id}
                  onClick={() => resumeChat(c.id)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    px: 1,
                    py: 0.75,
                    mb: 0.25,
                    borderRadius: 1.5,
                    cursor: "pointer",
                    bgcolor: c.id === chatId ? "#efe7f9" : "transparent",
                    "&:hover": { bgcolor: c.id === chatId ? "#efe7f9" : "#f3eefa" },
                    "&:hover .delChat": { opacity: 1 },
                  }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      noWrap
                      sx={{
                        fontSize: 13,
                        fontWeight: c.id === chatId ? 700 : 500,
                        color: "#344767",
                      }}
                    >
                      {c.title}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: "#9a93a8" }}>
                      {c.mode === "report" ? "Report" : "Ask"} · {timeAgo(c.updatedAt)}
                    </Typography>
                  </Box>
                  <IconButton
                    className="delChat"
                    size="small"
                    onClick={(e) => deleteChat(c.id, e)}
                    sx={{ opacity: 0, transition: "opacity 0.15s", color: "#b0a9bd" }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))
            )}
          </Box>
        </Box>

        {/* ── Chat area ── */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          {/* Top bar — history toggle + current chat title + new chat */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1.5,
              py: 0.75,
              borderBottom: "1px solid #f1eef7",
            }}
          >
            <IconButton
              size="small"
              onClick={() => setHistoryOpen((v) => !v)}
              title="Saved chats"
              sx={{ color: "#52009b" }}
            >
              <HistoryIcon />
            </IconButton>
            <Typography sx={{ fontSize: 13, color: "#7b809a", flex: 1 }} noWrap>
              {chatId
                ? chats.find((c) => c.id === chatId)?.title || "Saved chat"
                : reportMode
                ? "New report chat"
                : "New chat"}
            </Typography>
            {askMessages.length > 0 && (
              <Button
                size="small"
                startIcon={<AddIcon />}
                onClick={newChat}
                sx={{ color: "#52009b", textTransform: "none" }}
              >
                New chat
              </Button>
            )}
          </Box>
          {/* Welcome screen */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 4,
              overflowY: "auto",
            }}
          >
            <Box sx={{ maxWidth: 760, width: "100%", textAlign: "center" }}>
              <Typography variant="h5" fontWeight="bold" sx={{ color: "#52009b", mb: 0.5 }}>
                {reportMode ? "Build a Board Report" : "Ask PAGER"}
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
                {reportMode
                  ? "Explore your risks and emerging themes with me — ask what’s moving or where the exposure is — then tell me the scope and I’ll draft a board paper (Word or slides) when you’re ready."
                  : "Your latest emerging themes and watchlist risks to monitor. Ask which themes moved or which risks are worsening — or ask me to build a board paper when you’re ready."}
              </Typography>

              {brief && (brief.emergingThemes?.length || brief.activeRisks?.length) ? (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: 2,
                    textAlign: "left",
                    mb: 3,
                  }}
                >
                  {/* Emerging themes to watch */}
                  <Box
                    sx={{
                      border: "1px solid #e7e2ef",
                      borderRadius: 2,
                      p: 1.75,
                      bgcolor: "#faf9fc",
                    }}
                  >
                    <Typography
                      variant="overline"
                      sx={{ color: "#6a6478", fontWeight: 700, letterSpacing: 0.6 }}
                    >
                      Emerging themes to watch
                    </Typography>
                    {(brief.emergingThemes || []).map((t) => (
                      <Box
                        key={t.themeTag || t.name}
                        onClick={() => navigate("/anticipate/HorizonScan")}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          py: 0.6,
                          cursor: "pointer",
                          borderBottom: "1px solid #efeaf6",
                          "&:last-of-type": { borderBottom: "none" },
                          "&:hover .themeName": { color: "#52009b" },
                        }}
                      >
                        <Box
                          sx={{
                            flex: "none",
                            width: 24,
                            textAlign: "center",
                            fontSize: 11,
                            fontWeight: 800,
                            color: "#fff",
                            borderRadius: 0.75,
                            py: 0.15,
                            bgcolor: RATING_COLORS[t.rating] || "#9990a8",
                          }}
                        >
                          {t.rating || "–"}
                        </Box>
                        <Typography
                          className="themeName"
                          variant="body2"
                          sx={{ flex: 1, lineHeight: 1.3 }}
                        >
                          {t.name}
                        </Typography>
                        {t.newAlertsToday > 0 && (
                          <Box
                            sx={{
                              flex: "none",
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#0a5bb0",
                            }}
                          >
                            +{t.newAlertsToday} today
                          </Box>
                        )}
                      </Box>
                    ))}
                    {!(brief.emergingThemes || []).length && (
                      <Typography variant="body2" color="text.secondary" sx={{ py: 0.5 }}>
                        No rated themes yet.
                      </Typography>
                    )}
                  </Box>

                  {/* Watchlist risks to monitor */}
                  <Box
                    sx={{
                      border: "1px solid #e7e2ef",
                      borderRadius: 2,
                      p: 1.75,
                      bgcolor: "#faf9fc",
                    }}
                  >
                    <Typography
                      variant="overline"
                      sx={{ color: "#6a6478", fontWeight: 700, letterSpacing: 0.6 }}
                    >
                      Watchlist risks to monitor
                    </Typography>
                    {(brief.activeRisks || []).map((r) => (
                      <Box
                        key={r.id || r.title}
                        onClick={() => navigate("/anticipate/EmergingRisks")}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          py: 0.6,
                          cursor: "pointer",
                          borderBottom: "1px solid #efeaf6",
                          "&:last-of-type": { borderBottom: "none" },
                          "&:hover .riskName": { color: "#52009b" },
                        }}
                      >
                        <Typography
                          className="riskName"
                          variant="body2"
                          sx={{ flex: 1, lineHeight: 1.3 }}
                        >
                          {r.title}
                        </Typography>
                        {r.trendDirection === "worsening" && (
                          <Box
                            sx={{
                              flex: "none",
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#c62828",
                            }}
                          >
                            ⚠ worsening
                          </Box>
                        )}
                        {r.trendDirection === "improving" && (
                          <Box
                            sx={{
                              flex: "none",
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#2c7a50",
                            }}
                          >
                            ✓ improving
                          </Box>
                        )}
                      </Box>
                    ))}
                    {!(brief.activeRisks || []).length && (
                      <Typography variant="body2" color="text.secondary" sx={{ py: 0.5 }}>
                        No active watchlist risks.
                      </Typography>
                    )}
                  </Box>
                </Box>
              ) : null}

              {/* Ask PAGER thread */}
              {askMessages.length > 0 && (
                <Box
                  sx={{
                    textAlign: "left",
                    mb: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  {askMessages.map((m, i) => (
                    <React.Fragment key={i}>
                      {(m.text || m.role === "user" || !(m.proposal && !m.proposal.dismissed)) && (
                        <Box
                          sx={{
                            alignSelf: m.role === "user" ? "flex-end" : "flex-start",
                            maxWidth: "85%",
                            bgcolor: m.role === "user" ? "#52009b" : "#f3eefa",
                            color: m.role === "user" ? "#fff" : "#222028",
                            borderRadius: 2,
                            px: 1.5,
                            py: 1,
                            fontSize: 14,
                            whiteSpace: "pre-wrap",
                            lineHeight: 1.5,
                          }}
                        >
                          {m.text || (asking && i === askMessages.length - 1 ? "…" : "")}
                        </Box>
                      )}
                      {m.proposal && !m.proposal.dismissed && (
                        <ProposalCard
                          proposal={m.proposal}
                          onConfirm={() =>
                            m.proposal.kind === "board_paper"
                              ? generateBoardPaper(i)
                              : confirmAction(i)
                          }
                          onDismiss={() => dismissAction(i)}
                          onOpen={(riskId) =>
                            navigate("/anticipate/EmergingRisks", {
                              state: { openRiskId: riskId },
                            })
                          }
                          onOpenBoardPaper={(reportId) =>
                            navigate(`/anticipate/board-paper?view=${reportId}`)
                          }
                          onSave={() => finalizeBoardPaper(i)}
                          onRegenerate={(tweak) => regenerateBoardPaper(i, tweak)}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </Box>
              )}

              {/* Ask input */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  fullWidth
                  size="small"
                  inputRef={inputRef}
                  placeholder="Ask about today's risks — which themes moved, which risks are worsening…"
                  value={askInput}
                  onChange={(e) => setAskInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      askPager();
                    }
                  }}
                  disabled={asking}
                />
                <IconButton
                  onClick={askPager}
                  disabled={asking || !askInput.trim()}
                  sx={{
                    bgcolor: "#52009b",
                    color: "#fff",
                    "&:hover": { bgcolor: "#42007c" },
                    "&.Mui-disabled": { bgcolor: "#e7e2ef" },
                  }}
                >
                  {asking ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
                </IconButton>
              </Box>

              {/* Suggested starters (shown on the empty chat) */}
              {askMessages.length === 0 && (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  {(reportMode
                    ? [
                        "Build me a board paper for the last quarter",
                        "Summarise the whole portfolio for the board",
                        "Draft a paper on our worsening risks",
                        "Which risks should we escalate to the board?",
                      ]
                    : [
                        "What's emerging this week?",
                        "Which 3 themes should the board care about?",
                        "Which risks are worsening?",
                        "Build me a board paper",
                      ]
                  ).map((s) => (
                    <Button
                      key={s}
                      size="small"
                      variant="outlined"
                      disabled={asking}
                      onClick={() => askPager(s)}
                      sx={{
                        textTransform: "none",
                        color: "#52009b",
                        borderColor: "#d8c7ec",
                        bgcolor: "#fff",
                        "&:hover": { borderColor: "#52009b", bgcolor: "#f7f2fb" },
                      }}
                    >
                      {s}
                    </Button>
                  ))}
                </Box>
              )}

              {askMessages.length > 0 && (
                <Button
                  variant="outlined"
                  size="medium"
                  startIcon={<AddIcon />}
                  onClick={newChat}
                  sx={{
                    color: "#7b1fa2",
                    borderColor: "#c9a8e0",
                    "&:hover": { borderColor: "#7b1fa2", bgcolor: "#f7f2fb" },
                    textTransform: "none",
                    px: 3,
                  }}
                >
                  New chat
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
}
